import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';

interface FontCardsProps {
	previewText: string;
	dark: boolean;
}

const CHARSET_UPPER = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const CHARSET_LOWER = 'abcdefghijklmnopqrstuvwxyz';
const CHARSET_NUMS = '0123456789';

const FontCards = ({ previewText, dark }: FontCardsProps) => {
	const fonts = useSelector(
		(r: RootReducer) => r.mode.designSystemContent?.config?.fonts
	);
	const [previewWeight, setPreviewWeight] = useState<Record<number, string>>({});

	if (!fonts || fonts.length === 0) return null;

	return (
		<S.FontCardList>
			{fonts.map((font, idx) => {
				const weight = previewWeight[idx] ?? (font.fontWeight?.[0] ?? '400');
				const fontStack = `"${font.fontFamily}", ${font.fallback ?? 'sans-serif'}`;

				return (
					<S.FontCard key={`${font.fontFamily}-${idx}`}>
						<S.FontCardHeader $dark={dark}>
							<S.FontCardName>
								{font.fontFamily}
								<S.SourceBadge>{font.source}</S.SourceBadge>
							</S.FontCardName>
							<S.FontCardPreview
								$dark={dark}
								style={{ fontFamily: fontStack, fontWeight: Number(weight) }}
							>
								{previewText}
							</S.FontCardPreview>
							<S.FontCardCharset
								$dark={dark}
								style={{ fontFamily: fontStack, fontWeight: Number(weight) }}
							>
								{CHARSET_UPPER}
								<br />
								{CHARSET_LOWER}
								<br />
								{CHARSET_NUMS}
							</S.FontCardCharset>
						</S.FontCardHeader>
						{(font.fontWeight ?? []).length > 1 && (
							<S.FontCardMeta>
								{font.fontWeight!.map((w) => (
									<S.WeightPill
										key={w}
										type="button"
										$active={w === weight}
										onClick={() =>
											setPreviewWeight((prev) => ({ ...prev, [idx]: w }))
										}
									>
										{w}
									</S.WeightPill>
								))}
							</S.FontCardMeta>
						)}
					</S.FontCard>
				);
			})}
		</S.FontCardList>
	);
};

export default FontCards;
